import { Injectable } from '@angular/core';
import { BqxApplicationAbstractService } from 'bqx-application';
import { BqxAuthClientAbstractService } from 'bqx-auth';
import { IAuthClientCredentials } from 'bqx-auth/lib/services/auth-credentials-factory/auth-client-credential.interface';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { catchError, first, switchMap, takeUntil } from 'rxjs/operators';
import { AbstractAuthService } from './auth.abstract.service';

export const authAccessToken: BehaviorSubject<string> = new BehaviorSubject<string>(null);
@Injectable({
  providedIn: 'root'
})
export class AuthService implements AbstractAuthService {
  private _user;
  private _userName: string;
  private _userRoles: string;
  private _isAuthenticated = false;
  private _isLoggedOut = false;
  private _accessToken: string;
  private _authClient: IAuthClientCredentials;
  private unsubscribeSubject$: Subject<void> = new Subject<void>();
  private _sessionInvervalId;
  private _isBpLoggedIn$ = new BehaviorSubject<boolean>(false);

  get isBpLoggedIn$(): BehaviorSubject<boolean> {
    return this._isBpLoggedIn$;
  }

  get currentUser(): string {
    if (this._user) {
      const userFirstName = JSON.parse(this._user).UserAttributes[4].Value;
      const userLastName = JSON.parse(this._user).UserAttributes[5].Value;
      this._userName = userFirstName + ' ' + userLastName;
    }
    return this._userName;
  }

  get currentUserLanId(): string {
    let userLanId
    if (this._user) {
      const value = JSON.parse(this._user).UserAttributes[1].Value;
      const valueArray = JSON.parse(value);
      userLanId = valueArray[0].userId;
    }
    return userLanId;
  }

  get currentUserRoles(): string {
    this._userRoles = '';
    if (this._user) {
      this._userRoles = JSON.parse(this._user).UserAttributes[3].Value;
    }
    return this._userRoles;
  }
  get accessToken(): string {
    return this._accessToken;
  }
  get isAuthenticated(): boolean {
    return this._isAuthenticated;
  }
  get isLoggedOut(): boolean {
    return this._isLoggedOut;
  }

  get shouldHaveSearchAccess(): boolean {
    const roles = this.currentUserRoles.toUpperCase();
    return (
      roles.includes('BQX-BASE') ||
      roles.includes('BQX-SERVICEMANAGEMENT') ||
      roles.includes('BQX-SUPERVISOR') ||
      roles.includes('BQX-SPECIALIST')
    );
  }

  constructor(private authService: BqxAuthClientAbstractService, private bqxApplication: BqxApplicationAbstractService) {
    this._authClient = this.authService.authClient;
  }

  public authenticateUser(setInterval = true): Observable<boolean> {
    return this._authClient.credentials$.pipe(
      takeUntil(this.unsubscribeSubject$),
      first((credentials) => !!credentials),
      switchMap((x) => {
        this._isAuthenticated = true;
        this._isLoggedOut = false;
        this._accessToken = x.accessToken;
        authAccessToken.next(this._accessToken);
        this._user = localStorage.getItem('client-user');
        sessionStorage.removeItem('session_expired');
        if (setInterval) this.sessionTimedOut();
        if (localStorage.getItem('bp-sdk-token')) {
          this.bqxApplication.connect({ applicationType: 'Agent' }).subscribe((val) => {
            this._isBpLoggedIn$.next(val);
            return of(val);
          });
          return of(true);
        } else {
          return this.bqxApplication.connect({ applicationType: 'Agent' });
        }
      }),
      catchError((err) => {
        this._isAuthenticated = false;
        this._isLoggedOut = true;
        console.log('Authentication Error:', err);
        console.log('Un-Authorized User: Redirecting to about:blank');
        window.location.href = 'about:blank';
        return of(false);
      })
    );
  }

  private bqxLogout(): void {
    this.bqxApplication.disConnect().subscribe((val) => {
      if (!val) {
        this.isBpLoggedIn$.next(val);
        localStorage.removeItem('bp-sdk-token_id');
        sessionStorage.removeItem('token_id');
        sessionStorage.removeItem('app-uid-token');
      }
    });
  }

  public logout(isExpired = false): void {
    this._isAuthenticated = false;
    this._isLoggedOut = true;
    this.unsubscribeSubject$.next(null);
    this.unsubscribeSubject$.complete();
    sessionStorage.clear();
    this.bqxLogout();
    clearInterval(this._sessionInvervalId);
    this._sessionInvervalId = null;
    this._authClient.logout();
    if (isExpired) sessionStorage.setItem('session_expired', 'Y');
    else sessionStorage.setItem('session_expired', 'F');
  }

  private sessionTimedOut(): void {
    this._sessionInvervalId = setInterval(() => {
      if (!this._isLoggedOut)
        if (this._authClient.isCookieCredentialsExpired) {
          this.logout(true);
        }
    }, 10000);
  }
}
